<script setup>
import {ref} from "vue";
import createTenantVenue from "./components/createTenantVenue/index.vue"
import {addClubIgnore} from "@/api/club/ignoreTenant.js";
import router from "@/router/index.js";
import {addStoreIgnore} from "@/api/store/ignoreTenant.js";
import {addVenueIgnore} from "@/api/venue/ignoreTenant.js";

// 加载状态
const loading = ref(false)
/*基本信息相关*/
// 基本信息表单
const ruleForm = ref({
  storeLogo: null,
  name: null,
  nameEn: "Coming Soon ...",
  storeType: null,
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
    addressDetailEn: null
  },
  // 营业时间
  operatingHours: [{
    operatingTime: [],
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null
  }],
  serviceCities: [],
  nonSelfOperatedLink: null,
  serviceModeTypes: [],
  description: null,
  descriptionImages: [],
  descriptionEn: null,
  descriptionEnImages: [],
  referralOfficer: {
    name: null,
    phone: null
  },
  certificationType: null,
  partnerStores: [],
  bikeStoreName: null,
  // 负责人信息
  contactName: null,
  phone: null,
  contactEmail: null,
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  },
  assistsOperation: true,
  storeCoverImage: null,
  photoList: [],
  storeDiscoverCoverImage: null
})
// 处理表单提交新建俱乐部
const handleCreateTenantClub = async () => {
  try {
    loading.value = true
    await addVenueIgnore(ruleForm.value)
    router.push({ path: "/listTenantVenue" })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <div v-loading="loading" style="height: 100%">
    <createTenantVenue v-model="ruleForm" @success="handleCreateTenantClub"></createTenantVenue>
  </div>
</template>

<style scoped>

</style>
